import { css } from "@emotion/react";
import { ReactNode } from "react";
import { useStore } from "src/stores/Store";
import colors from "src/utils/colors";

interface Props {
  className?: string;
  type?: string;
  align?: string;
  onClick?: (e: any) => void;
  to?: string;
  children?: ReactNode;
}

export default function ItemMenuButton(props: Props) {
  const store = useStore();

  const styles = css`
    background: #fff;
    border: 1px solid ${colors.borderGray};
    width: 44px;
    height: 44px;
    border-radius: 100%;
    text-align: center;
    line-height: 44px;
    color: ${store.theme.orgColor};
    outline: none;
    cursor: pointer;
    padding: 0;
    font-size: 1rem;
    transition: border 0.25s;
    &:hover {
      border: 1px solid ${store.theme.orgColor};
    }
    ${props.type === "reverse" && reverseStyles};
    ${props.align === "right" && rightStyles};
    ${props.type === "delete" && deleteStyles};
  `;

  if (props.onClick) {
    return (
      <span
        css={styles}
        className={`inline-block ${props.className}`}
        onClick={props.onClick}
      >
        {props.children}
      </span>
    );
  }

  if (props.to) {
    return (
      <span
        css={styles}
        className={`inline-block ${props.className}`}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          window.location.href = props.to;
        }}
      >
        {props.children}
      </span>
    );
  }

  return (
    <button css={styles} className={`inline-block ${props.className}`}>
      {props.children}
    </button>
  );
}

const reverseStyles = css`
  background: #fff;
`;

const rightStyles = css`
  margin: 0 0 0 0.75rem;
`;

const deleteStyles = css`
  background: ${colors.bgGray};
  color: ${colors.dark};
`;
